import { useCallback } from 'react';
import usePrevious from '../../../hooks/usePrevious';

function isVisibleInThumbs(index, startIndex, assetsVisible) {
  const lowerLimit = startIndex;
  const upperLimit = startIndex + assetsVisible - 1;

  return index >= lowerLimit && index <= upperLimit;
}

export function useCarouselChanger(currentAssetIndex, assetsVisible, numberOfAssets) {
  const previousIndex = usePrevious(currentAssetIndex) || 0;

  return useCallback(
    carousel => {
      function calculateVisibleIndex() {
        const isGoingToNext = currentAssetIndex > previousIndex;

        let newCarouselIndex = isGoingToNext ? 0 : numberOfAssets;
        const step = isGoingToNext ? 1 : -1;
        const direction = isGoingToNext ? 'right' : 'left';

        while (!isVisibleInThumbs(currentAssetIndex, newCarouselIndex, assetsVisible)) {
          newCarouselIndex += step;
        }

        carousel.goToSlide(newCarouselIndex, direction);
      }

      if (
        carousel &&
        !isVisibleInThumbs(currentAssetIndex, carousel.state.currentSlide, assetsVisible)
      ) {
        calculateVisibleIndex();
      }
    },
    [currentAssetIndex, assetsVisible, numberOfAssets]
  );
}
